import React, { useEffect, useRef } from "react";
import clsx from "clsx";

const VideoStream = ({ setLocal, setRemote, connected}) => {
  const videoCurrent = useRef(null);
  const videoRemote = useRef(null);
  useEffect(() => {
    if (videoCurrent?.current && videoRemote?.current) {
      setLocal(videoCurrent.current);
      setRemote(videoRemote.current);
    }
  }, [videoCurrent?.current, videoRemote?.current]);
  return (
    <div
      className={clsx("w-full h-full flex items-center justify-center overflow-hidden relative rounded-b-3xl", !connected && "hidden")}
    >
      <video
        className={clsx(
          "min-w-full min-h-full absolute overflow-hidden max-w-none"
        )}
        ref={videoCurrent}
        autoPlay
        muted
        playsInline
      ></video>
      <video
          className={clsx(
              "rounded-xl overflow-hidden",
              connected && "rounded absolute z-20 w-28 h-auto right-4 top-8",
          )}
          ref={videoRemote}
          autoPlay
          playsInline
      ></video>
    </div>
  );
};

export default VideoStream;
